import { isSportDomain, isSportParselyApikey, isTg24Domain, isTg24ParselyApikey } from './aem-utils';

export function safeReplace(string, ...args) {
  return string && string.replace(...args);
}

export function safeLowerCase(string) {
  return string && string.toLowerCase();
}

export function safeUpperCase(string) {
  return string && string.toUpperCase();
}

export function escapeString(string) {
  return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}

export function removeTrailingSlash(pathname) {
  return pathname.replace(/(.*)\/$/, '$1');
}

export function removeTrailingHtmlExtension(pathname) {
  return pathname.replace(/(.*).html$/, '$1');
}

export const getBooleanFromString = (value) => {
  return value === 'true';
};

export const unixDateToString = (unixDate, months) => {
  return `${unixDate.getDate()} ${months[unixDate.getMonth()]} ${unixDate.getFullYear()}`;
};

export const truncateText = (text, maxLength = 50) => {
  let newText = '';
  // trim the string to the maximum length if is longer
  if (text.length > maxLength) {
    newText = text.substr(0, maxLength);
    // re-trim if we are in the middle of a word
    newText = newText.substr(0, Math.min(text.length, text.lastIndexOf(' ')));
    return `${newText}...`;
  } else {
    return text;
  }
};

/**
 * This function take a "section" string and returns
 * a "label" string removing the word "sport"
 * @param {string} label - the string to "clean"
 * @returns a string
 */
export const getLabelText = (label) => {
  let result = '';
  if (label && typeof label !== 'object') {
    const string = label.split('-');
    result =
      isSportDomain() || isSportParselyApikey()
        ? string.filter((item) => item !== 'sport').join(' ')
        : string.join(' ');
    result =
      isTg24Domain() || isTg24ParselyApikey() ? string.filter((item) => item !== 'tg24').join(' ') : string.join(' ');
  } else {
    result = label.label;
  }
  return result;
};

/**
 *
 * @param {String} svgBase64 - the svg in base64 format
 * @returns {String} the source to be used on <img> tag
 * example in React: <img src={getSvgImgSrc('PHN2ZyB2ZXJzaW9...PBGHg67')} />
 */
export const getSvgImgSrc = (svgBase64) => {
  return `data:image/svg+xml;base64, ${svgBase64}`;
};
